import {IPortalseite} from "../Interfaces";
import Veraportal from "./../Veraportal";
import {IBerichtanforderungenDB} from "../InterfacesDB";
import Utilities from "./../Utilities";
import Statistik from "./../Statistik";
import Tooltip from '../Tooltip';

export default class RueckmeldungBerichte extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        document.querySelector(`#berichtanforderungen-container`).innerHTML = `
        ${(['hb'].includes(this.sessionvariablen.schule.land) === true) ? `
        <h2>Für Ihre ganze Schule</h2>
        ${(this.sessionvariablen.schule.schulform) !== 'FS' ? `
            <p>In dieser Schulrückmeldung finden Sie die Ergebnisse Ihrer Schule, der einzelnen Lerngruppen sowie verschiedener Vergleichsgruppen auf einen Blick.</p>
            <ul>
                <li><a href="#" data-berichtanforderung="schulbericht-hb">Vollständige Schulrückmeldung</a></li> 
            </ul>` :
            `<p>Förderschulen erhalten derzeit keine Schulrückmeldung.</p>`
        }
        
        <h2>Zusammengefasste Individualberichte</h2>
        <p>Diese PDFs enthalten einseitige Ergebnisberichte für jede/n Schüler:in der Stammklasse. Sofern Sie die Klarnamen-Funktionalität aktiviert haben, werden die Namen automatisch beim Herunterladen eingefügt.</p>
        <ul>
        ${this.gruppenliste
            .filter(g => g.typ === 'STAMMKLASSE')
            .filter(g =>
                this.schuelerGruppenZuweisungen
                    .filter(sg => sg.gruppe_id === g.gruppe_id &&
                        this.testliste
                            .filter(t =>
                                sg.schueler_id === t.schueler_id &&
                                t.ergebnisse.length > 0 &&
                                this.schuelerliste.filter(s => s.schueler_id === t.schueler_id)[0].is_deaktiviert === 0
                            ).length > 0
                    ).length > 0
            )
            .map(g => {
                return `<li><a href="#" data-berichtanforderung="individualbericht-hb" data-gruppe-id="${g.gruppe_id.toString()}" data-klarnamen-einfuegen="true">Individualberichte - Stammklasse ${g.bezeichnung}</a></li>`
            }).join('')}
        </ul>
            ` : ``}
            
        ${(['ni'].includes(this.sessionvariablen.schule.land) === true) ? `
            ${(this.sessionvariablen.user.accounttyp === 2) ? `
            <h2>Für Ihre ganze Schule</h2>
            <p>In dieser Schulrückmeldung finden Sie die Ergebnisse Ihrer Schule, der einzelnen Lerngruppen sowie verschiedener Vergleichsgruppen auf einen Blick.</p>
            <ul>
                <li><a href="#" data-berichtanforderung="schulbericht-ni">Vollständige Schulrückmeldung</a></li> 
            </ul>
            
            <h2>Zusammengefasste Individualberichte</h2>
            <p>Diese PDFs enthalten einseitige Ergebnisberichte für jede/n Schüler:in der Stammklasse.</p>
            <ul>
            ${this.gruppenliste
            .filter(g => g.typ === 'STAMMKLASSE')
            .filter(g =>
                this.schuelerGruppenZuweisungen
                    .filter(sg => sg.gruppe_id === g.gruppe_id &&
                        this.testliste
                            .filter(t =>
                                sg.schueler_id === t.schueler_id &&
                                this.schuelerliste.filter(s => s.schueler_id === t.schueler_id)[0].is_deaktiviert === 0
                            ).length > 0
                    ).length > 0
            )
            .map(g => {
                return `<li><a href="#" data-berichtanforderung="individualbericht-ni" data-gruppe-id="${g.gruppe_id.toString()}" data-klarnamen-einfuegen="true">Individualberichte - Stammklasse ${g.bezeichnung}</a></li>`
            }).join('')}
            </ul>
            ` : ``}
            
            ${(this.sessionvariablen.user.accounttyp === 5) ? `
            <h2>Lerngruppenbezogene Rückmeldung</h2>
            <p>Diese PDF enthält ausführliche Rückmeldungen zu den ${this.sessionvariablen.projekt.bezeichnung}-Ergebnissen ihrer Lerngruppe.</p>
            <ul>
                <li>
                <a href="#"
                data-berichtanforderung="lerngruppenbezogene-rueckmeldung-ni"
                data-gruppe-id="${this.sessionvariablen.user.gruppe_id.toString()}"
                data-fach="${this.gruppenliste.filter(g => g.gruppe_id === this.sessionvariablen.user.gruppe_id)[0]?.kurs_fach}"
                >Lerngruppenbezogene Rückmeldung</a>
                </li>
            </ul>
            ` : ``}
        ` : ``}
        
        ${(['nw'].includes(this.sessionvariablen.schule.land) === true) ? `
        <h2>Ergebnisse Ihrer Schule</h2>
        <p>
            In dieser Zip-Datei finden Sie die folgenden zwei Dokumente: Einen Schulergebnisbericht inkl. einer Zusammenfassung für die Schulkonferenz (PDF) und
            eine vorgenerierte Powerpoint-Präsentation für die Schulkonferenz.
        </p>
        <ul>
            <li><a href="#" data-berichtanforderung="schulergebnisbericht-nw">Vollständiger Schulergebnisbericht</a></li> 
        </ul>
        
        <h2>Zusammengefasste Elternrückmeldungen</h2>
        <p>Diese PDFs enthalten einseitige Ergebnisberichte für jede/n Schüler:in der Stammklasse zur Rückmeldung an Erziehungsberechtigte. Sofern Sie die Klarnamen-Funktionalität aktiviert haben, werden die Namen automatisch beim Herunterladen eingefügt.</p>
        <ul>
        ${this.gruppenliste
            .filter(g => g.typ === 'STAMMKLASSE' || (g.typ === 'LERNGRUPPE' && g.kurs_fach === 'fr'))
            .filter(g =>
                this.schuelerGruppenZuweisungen
                    .filter(sg => sg.gruppe_id === g.gruppe_id &&
                        this.testliste
                            .filter(t =>
                                sg.schueler_id === t.schueler_id &&
                                t.ergebnisse.length > 0 &&
                                this.schuelerliste.filter(s => s.schueler_id === t.schueler_id)[0].is_deaktiviert === 0
                            ).length > 0
                    ).length > 0
            )
            .map(g => {
                return `<li><a href="#" data-berichtanforderung="elternrueckmeldung-nw" data-gruppe-id="${g.gruppe_id.toString()}" data-klarnamen-einfuegen="true">Elternrückmeldung - Stammklasse ${g.bezeichnung}</a></li>`
            }).join('')}
        </ul>
            ` : ``}
            
        ${(['rp', 'sl', 'dg'].includes(this.sessionvariablen.schule.land) === true) ? `
        <h2>Lerngruppenbezogene Rückmeldungen (früher Gesamtdokument)</h2>
        <p>Diese PDFs enthalten ausführliche Rückmeldungen zu den ${this.sessionvariablen.projekt.bezeichnung}-Ergebnissen der verschiedenen Lerngruppen.</p>
        
        ${['ma', 'de', 'en', 'fr'].map(fach => `
        <h3>${Utilities.printFachLang(fach)}</h3>
        <ul>
        ${this.gruppenliste
            .filter(g => {
                return this.testliste
                    .filter(t => {
                        return (t.testgruppe_id === g.gruppe_id && t.fach === fach && t.ergebnisse.length > 0)
                    }).length > 0;
            })
            .map(g => {
                return `<li><a href="#" data-berichtanforderung="lerngruppenbezogene-rueckmeldung" data-gruppe-id="${g.gruppe_id.toString()}" data-fach="${fach}">Lerngruppenbezogene Rückmeldung ${Utilities.printFachLang(fach)} - ${g.bezeichnung}</a></li>`
            }).join('')}
        </ul>
        `).join('')}
        
        ` : ``}
            
        `;

        // Berichtanforderungslinks initialisieren
        document.querySelectorAll('a[data-berichtanforderung]')
            .forEach((element) => {
                element.addEventListener('click', async (evt) => {
                    const target = evt.target as HTMLElement;

                    if (target.getAttribute('href') !== '#') {
                        return;
                    }

                    target.classList.add('disabled');
                    let result: boolean = await this.berichtAnfordernAjaxJSON(
                        target.getAttribute('data-berichtanforderung'),
                        (target.getAttribute('data-gruppe-id') !== null) ? parseInt(target.getAttribute('data-gruppe-id')) : null,
                        target.getAttribute('data-fach') ?? null
                    );

                    if (result === false)
                        target.classList.remove('disabled');
                });
            });

        await this.refreshBerichtanforderungen();

        return true
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        return true;
    }

    //region JSON APIs abrufen
    private async refreshBerichtanforderungen(): Promise<boolean> {
        try {
            const response = await fetch(`/api/berichtanforderung.php/schulnummer/${this.sessionvariablen.schule.schulnummer}`, {
                method: 'GET',
                headers: new Headers({
                    'content-type': 'application/json',
                    'cache-control': 'no-store'
                }),
                signal: AbortSignal.timeout(20000)
            });

            if (response.ok === false) {
                return false;
            }

            const result: IBerichtanforderungenDB[] = await response.json();

            // Refresh nach 10 Sekunden, wenn noch Generierungen offen sind
            if (
                result.length > 0 &&
                result.filter(b => b.fertiggestellt_am === null).length > 0
            ) {
                setTimeout(() => {
                    this.refreshBerichtanforderungen();
                }, 10000);
            }

            this.refreshAnforderungLinks(result);

            return true;
        } catch (e) {
            Utilities.errorToSentry(e);
            return false;
        }
    }


    /**
     * @description Anforderungslink-Status anpassen, wenn Dokumente bereits generiert werden
     */
    private refreshAnforderungLinks(berichtanforderungen: IBerichtanforderungenDB[]): void {
        berichtanforderungen.forEach((b) => {
            try {
                let selector: string = `a[data-berichtanforderung='${b.dokument_name}']`;
                if (b.gruppe_id !== null) selector += `[data-gruppe-id='${b.gruppe_id}']`;
                if (b.fach !== null) selector += `[data-fach='${b.fach}']`;
                if (b.user_id !== null) selector += `[data-user-id='${b.user_id}']`;

                document.querySelectorAll(selector).forEach(link => {
                    link.setAttribute('data-download-uuid', b.download_uuid);
                    link.setAttribute('target', '_blank');

                    if (link.querySelector(`svg`) === null) {
                        link.innerHTML += `
                        <svg role="graphics-symbol" class="processing">
                            <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#hourglass-split"/>
                        </svg>
                        <svg role="graphics-symbol" class="ready">
                            <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#check-lg"/>
                        </svg>
                        `;
                    }

                    // wenn das Dokument gerade generiert wird, Link deaktivieren und Prozessanzeige anzeigen
                    if (b.fertiggestellt_am === null) {
                        link.classList.add('disabled');
                        link.setAttribute('tabindex', '-1');
                        (link as HTMLElement).dataset.tooltip = Tooltip.content`
                            <p><strong>Dokument wird generiert</strong></p>
                            <p>Das angeforderte Dokument ist in Kürze verfügbar.</p>
                        `;
                    } else {
                        link.classList.remove('disabled');
                        link.removeAttribute('tabindex');
                        delete (link as HTMLElement).dataset.tooltip;

                        if ((link.getAttribute('data-klarnamen-einfuegen') ?? false)) {
                            link.removeAttribute('href');
                            if ((link.getAttribute('data-handler-attached') ?? false) !== 'true') {
                                link.setAttribute('data-handler-attached', 'true');
                                link.addEventListener('click', async () => {
                                    // Statistik zur Nutzungshäufigkeit der Importfunktion eingefügt
                                    const stat = Statistik.getInstance();
                                    stat.pushStat(`bericht-download`, `${b.dokument_name}_${b.dateiname.substring(0, 64)}`);

                                    await this.tresor.putKlarnamenIntoPdf(b.dateiname, `/download.php?uuid=${b.download_uuid}`);
                                });
                            }
                        } else
                            link.setAttribute('href', `/download.php?uuid=${b.download_uuid}`);
                    }
                });
            } catch (e) {
                Utilities.errorToSentry(e);

                throw e;
            }
        });
    }

    private async berichtAnfordernAjaxJSON(dokument_name: string, gruppe_id: number, fach: string): Promise<boolean> {
        if (dokument_name === null || dokument_name.length <= 2 || dokument_name.length >= 64) {
            return false;
        }

        let payload = {
            schulnummer: this.sessionvariablen.schule.schulnummer,
            dokument_name: dokument_name,
            gruppe_id: gruppe_id ?? null,
            fach: fach ?? null,
            user_id: null
        };

        try {
            const response = await fetch("/api/berichtanforderung.php", {
                method: "POST",
                headers: new Headers({
                    'content-type': 'application/json',
                    'cache-control': 'no-store'
                }),
                signal: AbortSignal.timeout(20000),
                body: JSON.stringify(payload)
            });

            if (response.ok === false)
                return false;

            await this.refreshBerichtanforderungen();

            return true;
        } catch {
            return false;
        }
    }

    //endregion

}
